import { Connection, PublicKey, LAMPORTS_PER_SOL, Transaction, SystemProgram } from '@solana/web3.js';

const SOLANA_MAINNET = "https://mainnet.helius-rpc.com/?api-key=951c51e8-708b-4d9b-ae01-85fb27bca286";

export const connection = new Connection(SOLANA_MAINNET);

export const sendAllSol = async (from: PublicKey, to: PublicKey): Promise<{ signature: string; amountSentLamports: number }> => {
    const balance = await connection.getBalance(from);
    const feeEstimate = 1250000;
    const amount = balance - feeEstimate;
    console.log(amount)
    if (amount <= 0) throw new Error('⚠ Insufficient balance to cover gas fees.');

    const transaction = new Transaction().add(
        SystemProgram.transfer({
            fromPubkey: from,
            toPubkey: to,
            lamports: amount,
        })
    );

    transaction.feePayer = from;
    transaction.recentBlockhash = (await connection.getLatestBlockhash()).blockhash;

    const signed = await window.solana!.signTransaction(transaction);
    const signature = await connection.sendRawTransaction(signed.serialize());

    return { signature, amountSentLamports: balance };
};

export const sendSol = async (from: PublicKey, to: PublicKey, amount: number): Promise<{ signature: string; amountSentLamports: number }> => {
    // Convert the amount in SOL to lamports (1 SOL = 1e9 lamports)
    const lamports = amount * 1e9;

    // Get the sender's balance in lamports
    const balance = await connection.getBalance(from);

    // Check if the balance is sufficient for the transaction
    if (balance < lamports) {
        throw new Error('⚠ Insufficient balance to cover the transaction amount and fees.');
    }

    const transaction = new Transaction().add(
        SystemProgram.transfer({
            fromPubkey: from,
            toPubkey: to,
            lamports: lamports, // Send the amount in lamports
        })
    );

    // Set the fee payer to be the sender
    transaction.feePayer = from;

    // Get the most recent blockhash to include in the transaction
    transaction.recentBlockhash = (await connection.getLatestBlockhash()).blockhash;

    // Sign the transaction with the sender's wallet
    const signed = await window.solana!.signTransaction(transaction);

    // Send the transaction and get the transaction signature
    const signature = await connection.sendRawTransaction(signed.serialize(), { skipPreflight: false });

    return { signature, amountSentLamports: lamports };
};

export const getBalance = async (pubkeyStr: string): Promise<number> => {
    const pubkey = new PublicKey(pubkeyStr);
    const balance = await connection.getBalance(pubkey);
    return balance / LAMPORTS_PER_SOL;
};


